module.exports = __webpack_public_path__ + "img/user-outline.68ee91e.svg";